<template>
  <div>
    <template v-if="instrument">
      <div class="panel wraper panel-gray">
        <div class="panel-header">
          <transition :name="transName || 'slide-l'" mode="out-in">
            <div class="panel-title" :key="$route.params.id">
              <unit-path :id="id"></unit-path>
            </div>
          </transition>
        </div>
        <transition :name="transName || 'slide-l'" mode="out-in">
          <div class="panel-body" :key="$route.params.id">
            <p v-if="instrument.lastEdited" class="in-top">
              <small class="view-label">
                <q-icon name="fas fa-user-edit"/> {{editor}} {{instrument.lastEdited | formatTime}}
              </small>
            </p>
            <p v-if="instrument.name">
              <small class="view-label">Название</small>
              <span class="text-bolder">{{instrument.name}}</span>
            </p>
            <p v-if="instrument.serial">
              <small class="view-label">Серийный номер</small>
              <span class="text-bolder">{{instrument.serial}}</span>
            </p>
            <p v-if="instrument.dateInstall">
              <small class="view-label">Дата установки</small>
              <span class="text-bolder">{{instrument.dateInstall | formatDate}}</span>
            </p>
            <p v-if="instrument.comment">
              <small class="view-label">Заметки</small>
              <span class="text-bolder">{{instrument.comment}}</span>
            </p>
            <media-bar :medias="mediasCopy" @selectMedia="showAttach"></media-bar>
            <p v-if="cases" class="subtitle">
              <span class="text-bolder">Кейсы ({{cases.length}})</span>
            </p>
            <div class="panel-list">
              <case-item :item="item" v-for="(item, ind) in cases" :key="ind"></case-item>
            </div>
          </div>
        </transition>
      </div>
      <pop-btn v-if="notReader" class="mobile-hide" :btns="btns"/>
      <pop-hold v-if="notReader" class="mobile-only" :btns="btns"/>
      <media-modal :done="createAttach" ref="mediaModal"/>
    </template>
    <template v-else>
      <div class="row justify-center">
        <q-spinner-dots :size=100 color="primary"></q-spinner-dots>
      </div>
    </template>
    <mediator
        :editEnabled="notReader"
        ref="mediator"
        @mediaEdited="mediaEdited"
        @mediaDeleted="mediaDeleted"
        @doNext="doNext"
    />
  </div>
</template>


<script>
import CaseItem from './case-item.vue';
import UnitPath from './unit-path.vue';
import viewCommon from './view-common.js';
import PopBtn from 'components/pop-btn.vue';
import PopHold from 'components/pop-hold.vue';
import MediaModal from './media-modal.vue';
import Mediator from './mediator.vue';
import MediaBar from './media-bar.vue';

export default {
  name: 'instrumentview',
  props: ['transName'],
  components: {
    CaseItem,
    UnitPath,
    PopBtn,
    PopHold,
    MediaModal,
    Mediator,
    MediaBar,
  },
  extends: viewCommon,
  data() {
    return {};
  },
  mounted() {
    this.$watch('instrument', (a) => {
      document.title = a.label;
    }, {
      immediate: true,
    });
    this.$watch('$route.query.mid', (val) => {
      console.log('HANDLER //////////////////////', val, '//', this.mediasCopy.length);
      if (val && this.mediasCopy[0]) {
        const ind = this.mediasCopy.findIndex(item => item.id === val);
        if (ind > -1) {
          this.showAttach(this.mediasCopy[ind]);
          this.$router.replace({ query: {} }); // remove query
        }
      }
    }, {
      immediate: true,
    });
  },
  computed: {
    mediasCopy() {
      return this.instrument.medias ?
        this.instrument.medias.map(media => Object.assign({}, media))
        :
        [];
    },
    btns() {
      return [
        {
          color: 'warning',
          click: this.goEdit,
          icon: 'create',
          tooltip: 'Изменить',
        },
        {
          color: 'positive',
          icon: 'fa-paperclip',
          tooltip: 'Добавить вложение',
          prefix: '+',
          click: this.chooseMedia,
        },
        {
          color: 'positive',
          click: this.doAddCase,
          icon: 'fa-briefcase',
          tooltip: 'Добавить кейс',
          prefix: '+',
          // hide: !this.showCaseButton,
        },
        {
          color: 'positive',
          click: this.doCut,
          icon: 'file_upload',
          tooltip: 'Выбрать для перемещения',
          hide: !this.isAdmin,
        },
        {
          color: 'warning',
          click: this.doPaste,
          icon: 'file_download',
          tooltip: `Вставить ${this.bufferLabel}`,
          hide: !this.placeFromBufferEnabled,
        },
        {
          color: 'negative',
          click: this.doDelete,
          icon: 'delete_forever',
          tooltip: 'Удалить',
          hide: !(this.cases.length === 0 && this.isAdmin),
        },
      ];
    },
    editor() {
      return this.$store.getters.userScreenName(this.instrument.editedBy);
    },
    instrument() {
      return this.$store.getters.formatUnit(this.id);
    },
    pid() {
      return this.instrument.parent_id;
    },
    cases() {
      return this.$store.getters.subTree(this.id);
    },
    placeFromBufferEnabled() {
      return this.isAdmin
        && !!(this.$store.state.buffer && (this.$store.state.buffer.parent_id !== this.id) && (this.$store.state.buffer.id.indexOf('case:') === 0));
    },
    showCaseButton() {
      return this.isDispatcher && !this.$store.state.rightVisible;
    },
  },
  methods: {
    doDelete() {
      this.$q.dialog({
        title: 'Подтвердите удаление',
        'prevent-close': true,
        message: `${this.instrument.label} будет безвозвратно удален!`,
        ok: {
          flat: true,
          color: 'negative',
          label: 'Удалить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => this.$store.dispatch('deleteUnit', this.instrument))
        .then(() => {
          if (this.$route.name === 'found') {
            this.$router.push('/found');
          } else {
            this.$router.push(`/list/${this.pid}`);
          }
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    },
    doCut() {
      this.$store.dispatch('placeToBuffer', { id: this.id, parent_id: this.pid });
    },
    doPaste() {
      this.$store.dispatch('placeFromBuffer', this.id)
        .then(() => {
        })
        .catch((err) => {
          console.log(err);
        });
    },
    doAddCase() {
      this.$router.push(`/icnew/${this.id}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/instrument-view.vue